import { IonCol, IonRow } from "@ionic/react";
import { Product } from "@core/types";
import classNames from "classnames/bind";
import styles from "./NewListViewProduct.module.scss";
import CartQuantityControl from "./CartQuantityControl";
import { useCartData } from "../../../../../providers/cartDataStore";
import React from "react";
import BasketIcon from "./BasketIcon";
import ProductPrice from "./ProductPrice";

interface DetailsRowProps {
  product: Product;
  type: "list-for-wish" | "newList";
}

const cx = classNames.bind(styles);

const DetailsRow = ({ product, type }: DetailsRowProps) => {
  const { cartProductsMap } = useCartData();
  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;

  return (
    <IonRow className={cx("ion-hide-sm-down")}>
      {!cartQuantity && <ProductPrice product={product} />}
      <IonCol
        sizeSm={!cartQuantity && product.stockStatus === "instock" ? "3" : "12"}
        className={cx({ productBasketWrapper: !cartQuantity }, "ion-no-padding")}
      >
        {!cartQuantity ? (
          <IonRow>
            <BasketIcon product={product} />
          </IonRow>
        ) : (
          <CartQuantityControl product={product} type={type} />
        )}
      </IonCol>
    </IonRow>
  );
};

export default DetailsRow;
